const getters = {
  loginVisible: state => state.app.loginVisible,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js